var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoLinkedin = function SvgLogoLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67 1.666c-1.107 0-2.003.9-2.003 2.006 0 1.107.896 2.006 2.003 2.006a2.005 2.005 0 0 0 2.002-2.006A2.005 2.005 0 0 0 3.67 1.666M5.397 7.2H1.942v11.133h3.455zM14.19 6.923c-1.68 0-2.807.923-3.268 1.798h-.046V7.2H7.563v11.132h3.451v-5.507c0-1.452.276-2.858 2.073-2.858 1.771 0 1.795 1.66 1.795 2.951v5.414h3.452v-6.106c0-2.997-.646-5.303-4.144-5.303"
  })));
};
export default SvgLogoLinkedin;